import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import RegistrationFormService from '../services/RegistrationFormService';
import ValidateableTextInputField from "./ValidateableTextInputField";

class PhoneNumber extends Component {

  validateValue = (value) => {
    return RegistrationFormService.validatePhoneNumber(value);
  };

  render() {
    return (
        <React.Fragment>
          <ValidateableTextInputField
              validationFunction={this.validateValue}
              onChange={this.props.onChange}
              fieldLabel={this.props.fieldLabel}
              showErrors={this.props.showErrors}
              maxLength="10"
          />
        </React.Fragment>
    )
  }
}

PhoneNumber.propTypes = {
  onChange: PropTypes.func.isRequired,
  fieldLabel: PropTypes.string,
  showErrors: PropTypes.bool
};

export default PhoneNumber;